import { render } from "./PendingPR.vue?vue&type=template&id=77fb9a6e"
import script from "./PendingPR.vue?vue&type=script&lang=js"
export * from "./PendingPR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__